module.exports = __webpack_public_path__ + "static/media/image-resize.646edb55.png";